<div [ngClass]="item.class" [innerHtml]="item.text"></div>
